// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/checklist_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_client } from "../../google/api/client_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../google/api/resource_pb";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/checklist_service.proto.
 */
export const file_api_v1_checklist_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_api_client, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * Checklist Item (single item in a template)
 *
 * @generated from message journal.api.v1.ChecklistItem
 */
export type ChecklistItem = Message<"journal.api.v1.ChecklistItem"> & {
  /**
   * Item text
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * Checked state (for display)
   *
   * @generated from field: bool checked = 2;
   */
  checked: boolean;

  /**
   * Optional category for grouping
   *
   * @generated from field: string category = 3;
   */
  category: string;
};

/**
 * Describes the message journal.api.v1.ChecklistItem.
 * Use `create(ChecklistItemSchema)` to create a new message.
 */
export const ChecklistItemSchema: GenMessage<ChecklistItem> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 0);

/**
 * Checklist Template
 *
 * @generated from message journal.api.v1.ChecklistTemplate
 */
export type ChecklistTemplate = Message<"journal.api.v1.ChecklistTemplate"> & {
  /**
   * Resource name: checklist-templates/{uid}
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Unique ID (used in name)
   *
   * @generated from field: string uid = 2;
   */
  uid: string;

  /**
   * Template metadata
   *
   * @generated from field: journal.api.v1.ChecklistTemplateType template_type = 3;
   */
  templateType: ChecklistTemplateType;

  /**
   * @generated from field: journal.api.v1.ChecklistCategory category = 4;
   */
  category: ChecklistCategory;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * Template content
   *
   * @generated from field: repeated journal.api.v1.ChecklistItem items = 7;
   */
  items: ChecklistItem[];

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * Creator reference (user ID)
   *
   * @generated from field: string creator_id = 10;
   */
  creatorId: string;

  /**
   * Populated in responses
   *
   * @generated from field: string creator_username = 11;
   */
  creatorUsername: string;
};

/**
 * Describes the message journal.api.v1.ChecklistTemplate.
 * Use `create(ChecklistTemplateSchema)` to create a new message.
 */
export const ChecklistTemplateSchema: GenMessage<ChecklistTemplate> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 1);

/**
 * Request message for CreateChecklistTemplate
 *
 * @generated from message journal.api.v1.CreateChecklistTemplateRequest
 */
export type CreateChecklistTemplateRequest = Message<"journal.api.v1.CreateChecklistTemplateRequest"> & {
  /**
   * @generated from field: journal.api.v1.ChecklistTemplate template = 1;
   */
  template?: ChecklistTemplate;

  /**
   * Auto-generate UID if not provided
   *
   * @generated from field: string uid = 2;
   */
  uid: string;
};

/**
 * Describes the message journal.api.v1.CreateChecklistTemplateRequest.
 * Use `create(CreateChecklistTemplateRequestSchema)` to create a new message.
 */
export const CreateChecklistTemplateRequestSchema: GenMessage<CreateChecklistTemplateRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 2);

/**
 * Request message for ListChecklistTemplates
 *
 * @generated from message journal.api.v1.ListChecklistTemplatesRequest
 */
export type ListChecklistTemplatesRequest = Message<"journal.api.v1.ListChecklistTemplatesRequest"> & {
  /**
   * Parent resource (optional, for filtering by creator)
   *
   * @generated from field: string parent = 1;
   */
  parent: string;

  /**
   * Filters
   *
   * @generated from field: journal.api.v1.ChecklistTemplateType template_type = 2;
   */
  templateType: ChecklistTemplateType;

  /**
   * @generated from field: journal.api.v1.ChecklistCategory category = 3;
   */
  category: ChecklistCategory;

  /**
   * Pagination
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 5;
   */
  pageToken: string;

  /**
   * Ordering
   *
   * e.g., "created_at", "updated_at"
   *
   * @generated from field: string order_by = 6;
   */
  orderBy: string;
};

/**
 * Describes the message journal.api.v1.ListChecklistTemplatesRequest.
 * Use `create(ListChecklistTemplatesRequestSchema)` to create a new message.
 */
export const ListChecklistTemplatesRequestSchema: GenMessage<ListChecklistTemplatesRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 3);

/**
 * Response message for ListChecklistTemplates
 *
 * @generated from message journal.api.v1.ListChecklistTemplatesResponse
 */
export type ListChecklistTemplatesResponse = Message<"journal.api.v1.ListChecklistTemplatesResponse"> & {
  /**
   * @generated from field: repeated journal.api.v1.ChecklistTemplate templates = 1;
   */
  templates: ChecklistTemplate[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message journal.api.v1.ListChecklistTemplatesResponse.
 * Use `create(ListChecklistTemplatesResponseSchema)` to create a new message.
 */
export const ListChecklistTemplatesResponseSchema: GenMessage<ListChecklistTemplatesResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 4);

/**
 * Request message for GetChecklistTemplate
 *
 * @generated from message journal.api.v1.GetChecklistTemplateRequest
 */
export type GetChecklistTemplateRequest = Message<"journal.api.v1.GetChecklistTemplateRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Alternative: use UID directly
   *
   * @generated from field: string uid = 2;
   */
  uid: string;
};

/**
 * Describes the message journal.api.v1.GetChecklistTemplateRequest.
 * Use `create(GetChecklistTemplateRequestSchema)` to create a new message.
 */
export const GetChecklistTemplateRequestSchema: GenMessage<GetChecklistTemplateRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 5);

/**
 * Request message for UpdateChecklistTemplate
 *
 * @generated from message journal.api.v1.UpdateChecklistTemplateRequest
 */
export type UpdateChecklistTemplateRequest = Message<"journal.api.v1.UpdateChecklistTemplateRequest"> & {
  /**
   * @generated from field: journal.api.v1.ChecklistTemplate template = 1;
   */
  template?: ChecklistTemplate;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;

  /**
   * Allow timestamp updates (for testing)
   *
   * @generated from field: bool allow_update_timestamps = 3;
   */
  allowUpdateTimestamps: boolean;
};

/**
 * Describes the message journal.api.v1.UpdateChecklistTemplateRequest.
 * Use `create(UpdateChecklistTemplateRequestSchema)` to create a new message.
 */
export const UpdateChecklistTemplateRequestSchema: GenMessage<UpdateChecklistTemplateRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 6);

/**
 * Request message for DeleteChecklistTemplate
 *
 * @generated from message journal.api.v1.DeleteChecklistTemplateRequest
 */
export type DeleteChecklistTemplateRequest = Message<"journal.api.v1.DeleteChecklistTemplateRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Alternative: use UID directly
   *
   * @generated from field: string uid = 2;
   */
  uid: string;
};

/**
 * Describes the message journal.api.v1.DeleteChecklistTemplateRequest.
 * Use `create(DeleteChecklistTemplateRequestSchema)` to create a new message.
 */
export const DeleteChecklistTemplateRequestSchema: GenMessage<DeleteChecklistTemplateRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_checklist_service, 7);

/**
 * Checklist Template Type
 *
 * @generated from enum journal.api.v1.ChecklistTemplateType
 */
export enum ChecklistTemplateType {
  /**
   * @generated from enum value: CHECKLIST_TEMPLATE_TYPE_UNSPECIFIED = 0;
   */
  CHECKLIST_TEMPLATE_TYPE_UNSPECIFIED = 0,

  /**
   * System default template
   *
   * @generated from enum value: SYSTEM = 1;
   */
  SYSTEM = 1,

  /**
   * User-created template
   *
   * @generated from enum value: USER = 2;
   */
  USER = 2,
}

/**
 * Describes the enum journal.api.v1.ChecklistTemplateType.
 */
export const ChecklistTemplateTypeSchema: GenEnum<ChecklistTemplateType> = /*@__PURE__*/
  enumDesc(file_api_v1_checklist_service, 0);

/**
 * Checklist Category
 *
 * @generated from enum journal.api.v1.ChecklistCategory
 */
export enum ChecklistCategory {
  /**
   * @generated from enum value: CHECKLIST_CATEGORY_UNSPECIFIED = 0;
   */
  CHECKLIST_CATEGORY_UNSPECIFIED = 0,

  /**
   * Value investing checklist
   *
   * @generated from enum value: VALUE_INVESTING = 1;
   */
  VALUE_INVESTING = 1,

  /**
   * Technical analysis checklist
   *
   * @generated from enum value: TECHNICAL = 2;
   */
  TECHNICAL = 2,

  /**
   * Short-term trading checklist
   *
   * @generated from enum value: SPECULATION = 3;
   */
  SPECULATION = 3,

  /**
   * Custom user category
   *
   * @generated from enum value: CUSTOM = 4;
   */
  CUSTOM = 4,
}

/**
 * Describes the enum journal.api.v1.ChecklistCategory.
 */
export const ChecklistCategorySchema: GenEnum<ChecklistCategory> = /*@__PURE__*/
  enumDesc(file_api_v1_checklist_service, 1);

/**
 * Checklist Template Service
 *
 * @generated from service journal.api.v1.ChecklistService
 */
export const ChecklistService: GenService<{
  /**
   * CreateChecklistTemplate creates a new checklist template
   *
   * @generated from rpc journal.api.v1.ChecklistService.CreateChecklistTemplate
   */
  createChecklistTemplate: {
    methodKind: "unary";
    input: typeof CreateChecklistTemplateRequestSchema;
    output: typeof ChecklistTemplateSchema;
  },
  /**
   * ListChecklistTemplates lists all checklist templates with pagination
   *
   * @generated from rpc journal.api.v1.ChecklistService.ListChecklistTemplates
   */
  listChecklistTemplates: {
    methodKind: "unary";
    input: typeof ListChecklistTemplatesRequestSchema;
    output: typeof ListChecklistTemplatesResponseSchema;
  },
  /**
   * GetChecklistTemplate gets a checklist template by resource name or UID
   *
   * @generated from rpc journal.api.v1.ChecklistService.GetChecklistTemplate
   */
  getChecklistTemplate: {
    methodKind: "unary";
    input: typeof GetChecklistTemplateRequestSchema;
    output: typeof ChecklistTemplateSchema;
  },
  /**
   * UpdateChecklistTemplate updates a checklist template
   *
   * @generated from rpc journal.api.v1.ChecklistService.UpdateChecklistTemplate
   */
  updateChecklistTemplate: {
    methodKind: "unary";
    input: typeof UpdateChecklistTemplateRequestSchema;
    output: typeof ChecklistTemplateSchema;
  },
  /**
   * DeleteChecklistTemplate deletes a checklist template (soft delete)
   *
   * @generated from rpc journal.api.v1.ChecklistService.DeleteChecklistTemplate
   */
  deleteChecklistTemplate: {
    methodKind: "unary";
    input: typeof DeleteChecklistTemplateRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_checklist_service, 0);

